export const GET_SALES_INVOICES_PAGINATED = gql`
    query GetSalesInvoicesPaginated($filters: SalesInvoiceTableFiltersInput) {
        getSalesInvoicesPaginated(filters: $filters) {
            data {
                id
                status
                createdAt
                merchant {
                    id
                    displayName
                    merchantAccountNumber
                }
                invoiceNumber
            }
            total
            page
            pageSize
        }
    }
`;
